/**=========================================================
* Module: config.js
* App routes and resources configuration
=========================================================*/

App.config([
  "$stateProvider",
  "$locationProvider",
  "$urlRouterProvider",
  "RouteHelpersProvider",
  function (
    $stateProvider,
    $locationProvider,
    $urlRouterProvider,
    helper
  ) {
    "use strict";
    lg("Loading routes...");
    // Set the following to true to enable the HTML5 Mode
    // You may have to set <base> tag in index and a routing configuration in your server
    $locationProvider.html5Mode(true);

    // `/templates/` does not match `app.campaigns_templates` (strict mode), so
    // it falls through to `app.campaign_template` ("/templates/:id") with an
    // empty id, whose controller then redirects to "/templates//actions" and
    // loads a template that does not exist. Send it to the list instead.
    $urlRouterProvider.when("/templates/", "/templates/default");

    $urlRouterProvider.when("/app/setup/external-booking-links", "/app/setup/partner-integrations");

    // default route
    $urlRouterProvider.otherwise(function ($injector) {
      var $state = $injector.get("$state");
      $state.go('app.home')
    });

    //
    // Application Routes
    // -----------------------------------
    $stateProvider
      .state("application_access", {
        url: "/application_access/:jwt_token",
        templateUrl: helper.basepath("application_access.html"),
        data: {
          title: "API Access"
        }
      })
      .state("onboarding", {
        url: "/onboardings/:hashid?id&type",
        resolve: helper.resolveFor("legacy"),
        controller: "onboardingCtrl",
        templateUrl: helper.basepath("onboarding.html"),
        data: {
          title: "Onboarding"
        }
      })
      .state("loa", {
        url: "/loas/:hashid",
        resolve: helper.resolveFor("legacy"),
        controller: "loaCtrl",
        templateUrl: helper.basepath("loa.html"),
        data: {
          title: "Letter of Authorization"
        }
      })
      .state("legal-preview", {
        url: "/sms-registration/preview/:documentType",
        templateUrl: helper.basepath("legal-preview.html"),
        data: {
          title: "Policy Preview"
        }
      })
      .state("payers", {
        url: "/payers",
        templateUrl: helper.basepath("payers.html"),
        data: {
          title: "Supported Payers"
        }
      })
      .state('oauth_callback', {
        url: '/auth/callback?code&state&open_mfa_reminder',
        templateUrl: helper.basepath('user-authentication/oauth_callback.html'),
        controller: 'oAuthCallbackCtrl',
        resolve: helper.resolveFor("legacy", 'toaster', 'ladda', 'schema-form', 'home'),
        data: {
          title: 'OAuth Callback',
        },
      })
      .state("patient-survey-form", {
        url: "/survey/take/:surveyId/:appointmentId/:instSubdomain/:score",
        templateUrl: helper.basepath("surveys/survey-patient-form.html"),
        params: {
          data: null,
          appointment: null,
          redirecting: false,
          timeRedirectionStarted: null,
          links_values: [],
          score: { squash: true, value: null },
        },
        data: {
          title: "Fill out a Survey",
        },
      })
      // Payments
      .state("patient-payments-online", {
        url: "/patient-payments-online/:institutionId/:locationId",
        abstract: true,
        templateUrl: helper.basepath("payments/base.html"),
      })
      .state("patient-payments-online.patient_search", {
        url: "/search",
      })
      .state("patient-payments-online.patient_search.verify", {
        url: "/verify",
      })
      .state("patient-payments-online.pay", {
        url: "/pay",
      })
      .state("patient-payments-online.pay_invoice", {
        url: "/pay-invoice/:paymentUuid/:rememberToken",
      })
      .state("patient-payments-online.invoices", {
        url: "/invoices/:patient_id/:remember_token",
      })
      // Patient online payment using a link_obfuscate shortened link
      .state("patient_make_payment_link", {
        url: "/pay/:code",
        templateUrl: helper.basepath("payments/base.html"),
      })
      .state("patient_checkout", {
        url: "/pay/:paymentId/:institutionId/:rememberToken",
        templateUrl: helper.basepath("payments/base.html"),
      })
      .state("patient_checkout_thank_you", {
        url: "/pay/:paymentId/:institutionId/:rememberToken/thank-you",
        templateUrl: helper.basepath("payments/base.html"),
      })
      .state("payment_not_found_page", {
        url: "/pay/not-found",
        templateUrl: helper.basepath("payments/base.html"),
      })
      .state("payment_status_page", {
        url: "/payments/:payment_id/status",
        templateUrl: helper.basepath("payments/base.html"),
      })
      // Patient's form
      .state("patient_form_common", {
        url: "/forms/:formId",
        templateUrl: helper.basepath("patient-form/layout.html"),
        controller: "patientFormCtrl",
        resolve: helper.resolveFor("legacy", "fontawesome", "stripe"),
        data: {
          title: "Form",
        },
      })
      .state("patient_filtered_form_common", {
        url: "/filtered-forms/:formId/:filterType/:filterId",
        templateUrl: helper.basepath("patient-form/layout.html"),
        controller: "patientFormCtrl",
        resolve: helper.resolveFor("legacy", "fontawesome", "stripe"),
        data: {
          title: "Form",
        },
      })
      .state("patient_form_individual", {
        url: "/forms/:formId/:rememberToken",
        templateUrl: helper.basepath("patient-form/layout.html"),
        controller: "patientFormCtrl",
        resolve: helper.resolveFor("legacy", "fontawesome", "stripe"),
        data: {
          title: "Form",
        },
      })
      .state("patient_form_thank_you", {
        url: "/forms_thank_you",
        templateUrl: helper.basepath("patient-form/thank_you.html"),
        data: {
          title: "Thank you",
        },
      })
      .state("installation", {
        url: "/installations/:hashid",
        resolve: helper.resolveFor("legacy"),
        controller: "installationCtrl",
        templateUrl: helper.basepath("installation.html"),
        data: {
          title: "Installation"
        }
      })
      // App
      .state("app", {
        url: "/app",
        abstract: true,
        templateUrl: helper.basepath("app.html"),
        controller: "appController",
        resolve: helper.resolveFor(
          "modernizr",
          "icons",
          "ngDialog",
          "toaster",
          "ladda",
          "sweet-alert",
          "xEditable"
        ),
      })
      .state('app.automations', { url: '/automations?name'} )
      .state('app.automations_manual', { url: '/automations/manual?name'} )
      .state('app.automations_continuing_care_recall', { url: '/automations/type/continuing_care_recall?name'} )
      .state('app.automations_type', { url: '/automations/type/:type'} )
      .state('app.automations_show', { url: '/automations/:id'} )
      .state("app.automation_schedule_editor", {
        url: "/automations/schedules/:id/editor/:type",
        data: {
          title: "Automation editor",
        },
      })
      .state("app.automation_schedule_editor_preview", {
        url: "/automations/schedules/:id/editor/:type/preview",
        data: {
          title: "Automation preview",
        },
      })
      .state("app.campaigns_templates", {
        url: "/templates",
        templateUrl: helper.basepath("campaigns/layout_header.html"),
        controller: "campaignsTemplatesHeaderCtrl",
        resolve: helper.resolveFor("legacy", 
          "datepicker",
          "sweet-alert",
          "ladda",
          "angularFileUpload"
        ),
        data: {
          title: "Templates",
        },
      })
      .state("app.campaigns_templates.default", {
        url: "/default",
        templateUrl: helper.basepath("campaigns/layout_templates.html"),
        controller: "campaignsCtrl",
        resolve: helper.resolveFor("ngTable"),
        data: {
          title: "Templates",
        },
        params: {
          isTemplates: true,
        },
      })
      .state("app.campaigns_templates.custom", {
        url: "/custom",
        templateUrl: helper.basepath("campaigns/layout_custom_templates.html"),
        controller: "campaignsCtrl",
        resolve: helper.resolveFor("ngTable"),
        data: {
          title: "Custom templates",
        },
        params: {
          is_custom: true,
        },
      })
      .state("app.campaigns_templates.settings", {
        url: "/settings",
        templateUrl: helper.basepath("campaigns/settings/layout.html"),
        controller: "CampaingsSettingsCtrl",
        data: {
          title: "Settings",
        },
      })
      .state("app.campaign_template", {
        url: "/templates/:id",
        templateUrl: helper.basepath("campaigns/campaign_template/layout.html"),
        controller: "campaignTemplateCtrl",
        resolve: helper.resolveFor("legacy", 
          "ngTable",
          "datepicker",
          "sweet-alert",
          "ladda",
          "angularFileUpload"
        ),
        data: {
          title: "Template",
        },
      })
      .state("app.campaign_schedule_editor", {
        url: "/templates/schedules/:id/editor/:type",
        data: {
          title: "Template editor",
        },
      })
      .state("app.campaign_schedule_editor_preview", {
        url: "/templates/schedules/:id/editor/:type/preview",
        data: {
          title: "Template preview",
        },
      })
      .state("app.campaign_template.actions", {
        url: "/actions",
        templateUrl: helper.basepath(
          "campaigns/campaign_template/actions/layout.html"
        ),
        controller: "campaignTemplateActionsCtrl",
        resolve: helper.resolveFor(
          "ngDialog",
          "wysiwyg",
          "angularFileUpload",
          "filestyle",
          "sweet-alert",
          "ladda"
        ),
        params: {
          open_appt_type_custom_dialog: false,
        },
      })
      .state("app.campaign_template.performance_old", {
        url: "/performance",
        templateUrl: helper.basepath(
          "campaigns/campaign_template/performance/layout.html"
        ),
        controller: "campaignTemplatePerformanceCtrl",
        data: {
          title: "Campaign Performance",
        },
        params: {
          date: null,
        },
        resolve: helper.resolveFor("datepicker", "ngTable", "daterangepicker"),
      })
      .state("app.campaign_template.performance", {
        url: "/performance/:survey_id?",
        templateUrl: helper.basepath(
          "campaigns/campaign_template/performance/layout.html"
        ),
        controller: "campaignTemplatePerformanceCtrl",
        data: {
          title: "Campaign Performance",
        },
        params: {
          date: null,
        },
        resolve: helper.resolveFor("datepicker", "ngTable", "daterangepicker"),
      })
      .state("app.campaign_template.history", {
        url: "/history",
        templateUrl: helper.basepath(
          "campaigns/campaign_template/history/layout.html"
        ),
        controller: "campaignTemplateHistoryCtrl",
        resolve: helper.resolveFor("ngTable"),
        data: {
          title: "Template History",
        },
      })
      .state("app.campaigns_templates.type_active", {
        url: "/type/:type/active",
        templateUrl: helper.basepath(
          "campaigns/campaign_template/type/active/layout.html"
        ),
        controller: "campaignTemplateTypeCtrl",
        params: {
          is_appointment_type: true,
          isArchived: false,
        },
      })
      .state("app.campaigns_templates.type_archived", {
        url: "/type/:type/archived",
        templateUrl: helper.basepath(
          "campaigns/campaign_template/type/archived/layout.html"
        ),
        controller: "campaignTemplateTypeCtrl",
        params: {
          is_appointment_type: true,
          isArchived: true,
        },
      })
      .state("app.campaigns_manuals", { url: "/campaigns?name&sort&page", })
      .state("app.campaigns_manuals_sent", { url: "/campaigns/sent?name&sort&page" })
      .state("app.campaigns_manuals_scheduled", { url: "/campaigns/scheduled?name&sort&page" })
      .state("app.campaigns_manuals_favorites", { url: "/campaigns/favorites?name&sort&page" })
      .state("app.campaigns_manuals_archive", { url: "/campaigns/archived?name&sort&page" })
      .state("app.campaigns_manuals_all", { url: "/campaigns/all?name&sort&page" })
      .state("app.campaign_manual", { url: "/campaigns/:id" })
      .state("app.campaign_manual_audience", { url: "/campaigns/:id/audience" })
      .state("app.campaign_manual_audience_step", { url: "/campaigns/:id/audience/:step" })
      .state("app.campaign_manual_preview", { url: "/campaigns/:id/preview?page" })
      .state("app.campaign_manual_build", { url: "/campaigns/:id/build" })
      .state("app.campaign_manual_email_editor", { url: "/campaigns/:id/editor/email" })
      .state("app.campaign_manual_sms_editor", { url: "/campaigns/:id/editor/sms" })
      .state("app.campaign_manual_email_preview", { url: "/campaigns/:id/editor/preview" })
      .state("app.campaign_manual_preview_react", {
        url: "/campaigns/:id/editor/:type/preview",
        template: () => '',
      })
      .state("app.analytics-download", {
        url: "/analytics/data-exports/:id",
        template: () => '',
        data: {
          title: "Analytics",
        },
      })
      .state("app.analytics", {
        url: "/analytics/:mode?/?from-date&to-date",
        templateUrl: helper.basepath("analytics/layout.html"),
        controller: "analyticsCtrl",
        resolve: helper.resolveFor("legacy", "plotly", "daterangepicker", "ChartJs"),
        data: {
          title: "Analytics",
        },
      })
      .state("app.analytics-v2", { url: "/insights" })
      .state("app.marketplace", {
        data: {
          title: "Marketplace",
        },
      })
      .state("app.refer_a_practice", {
        data: {
          title: "Refer a Practice",
        },
      })
      .state("app.activities", {
        url: "/dashboard",
        data: {
          title: "Dashboard",
        },
      })
      .state("app.home", {
        url: "/home",
        data: {
          title: "Dashboard",
        },
      })
      .state("app.activities_page", {
        url: "/activity",
        data: {
          title: "Activities",
        },
      })
      .state("app.activities_page.archive", {
        url: "/archive",
        data: {
          title: "Activities (archive)",
        },
      })
      .state("app.online_booking_dashboard", {
        url: "/online_booking",
        data: { title: "Online Booking" },
      })
      .state("app.online_booking_dashboard.patients", {
        url: "/patients",
        data: { title: "Patients" },
      })
      .state("app.forms_packets", { url: "/forms-packets",})
      .state("app.forms_packets_packets", { url: "/forms-packets/packets" })
      .state("app.forms_packets_drafts", { url: "/forms-packets/drafts" })
      .state("app.forms_packets_editor", { url: "/forms-packets/:id/editor" })
      .state("app.forms_packets_preview", { url: "/forms-packets/:id/preview" })
      .state("app.forms_packets_archived", { url: "/forms-packets/archived" })
      .state("app.settings", {
        url: "/settings",
        templateUrl: helper.basepath("setup/layout.html"),
        controller: "setupCtrl",
      })
      .state("app.settings.personal", {
        url: "/personal?section",
        data: {
          title: "Personal Info",
        },
      })
      .state("app.settings.notifications", {
        url: "/notifications",
        data: {
          title: "Notifications",
        },
      })
      .state("app.setup", {
        url: "/setup",
        templateUrl: helper.basepath("setup/layout.html"),
        resolve: helper.resolveFor("ngTable"),
        controller: "setupCtrl",
        data: {
          title: "Setup",
        },
      })
      .state("app.setup.logo", {
        url: "/logo",
        data: {
          title: "Logo",
        },
      })
      .state("app.setup.messages", {
        url: "/messages"
      })
      .state("app.setup.coworker", {
        url: "/coworker",
        data: {
          title: "Coworker",
        },
      })
      .state("app.setup.coworker.test_drive", {
        url: "/test-drive",
        data: {
          title: "Test drive",
        },
      })
      .state("app.setup.phone-connection", {
        url: "/phone-connection",
        data: {
          title: "Phone Connection",
        },
      })
      .state("app.setup.permissions", {
        url: "/permissions"
      })
      .state("app.setup.users", {
        url: "/users"
      })
      .state("app.setup.users.invite", {
        url: "/invite"
      })
      .state("app.setup.synchronizer", {
        url: "/synchronizer"
      })
      .state("app.setup.sms-registration", {
        url: "/sms-registration",
      })
      .state("app.setup.insurances", {
        url: "/insurances",
      })
      .state("app.setup.eligibility-report-sync", {
        url: "/eligibility-report-sync"
      })
      .state("app.setup.insurance-usage-management", {
        url: "/insurance-usage-management"
      })
      .state("app.setup.blocked-insurance-payers", {
        url: "/blocked-insurance-payers"
      })
      .state("app.setup.insurance-verification-window", {
        url: "/insurance-verification-window"
      })
      .state("app.setup.insurance-verification-configuration", {
        url: "/insurance-verification-configuration"
      })
      .state("app.setup.insurance-portal-credentials", {
        url: "/insurance-portal-credentials"
      })
      .state("app.setup.online_booking_form", {
        url: "/online-booking-form"
      })
      .state("app.setup.templates", {
        url: "/templates",
        data: {
          title: "Templates",
        },
      })
      .state("app.setup.automations", {
        url: "/automations",
        data: {
          title: "Automations",
        },
      })
      .state('app.feature', {
        url: '/features/:featureSlug',
      })
      .state("app.onboarding-overview", {
        url: "/onboarding-overview",
      })
      .state("app.onboarding-overview.product-area", {
        url: "/:productArea",
      })
      .state("app.setup.waitlist", {
        url: "/waitlist",
        data: {
          title: "Waitlist",
        },
      })
      .state("app.setup.payments", {
        url: "/payments",
        data: {
          title: "Payments",
        },
      })
      .state("app.setup.payment-configurations", {
        url: "/payment-configurations",
        data: {
          title: "Payment Configurations",
        },
      })
      .state("app.setup.payment-registrations", {
        url: "/payment-registrations",
        data: {
          title: "Payment Registrations",
        },
      })
      .state("app.setup.payment-processing-fees", {
        url: "/payment-processing-fees",
        data: {
          title: "Payment Processing Fees",
        },
      })
      .state("app.setup.payment-plans", {
        url: "/payment-plans",
        data: {
          title: "Payment Plans",
        },
      })
      .state("app.setup.appointment_types", {
        url: "/appointment-types?bulk_edit",
        params: { bulk_edit: null },
      })
      .state("app.setup.appointment_types.mappings", {
        url: "/mappings",
        data: {
          title: "Appointment Type Mappings",
        },
      })
      .state("app.setup.availability", {
        url: "/availability",
        templateUrl: helper.basepath("setup/tabs/availability/layout.html"),
        resolve: helper.resolveFor(
          "ngTable",
          "angularFileUpload",
          "filestyle",
          "datepicker"
        ),
        controller: "setupAvailabilityCtrl",
        data: {
          title: "Availability",
        },
      })
      .state("app.setup.availability.advanced", {
        url: "/advanced",
        data: {
          title: "Advanced Availability Settings",
        },
      })
      .state("app.setup.availability.edit", {
        url: "/edit",
        data: {
          title: "Edit schedulable entities",
        },
      })
      .state("app.setup.availability.edit.single", {
        url: "/:id",
        data: {
          title: "Edit schedulable entity",
        },
      })
      .state("app.setup.partner_integrations", {
        url: "/partner-integrations",
        data: { title: "Partner Integrations" },
      })
      .state("app.setup.online_booking_links", {
        url: "/online-booking-links",
        data: { title: "Online Booking Links" },
      })
      .state("app.setup.smart_commands", {
        url: "/smart_commands",
        data: {
          title: "Smart Commands",
        },
      })
      .state("app.setup.access", {
        url: "/access",
        data: {
          title: "Access",
        },
      })
      .state("app.setup.insights", {
        url: "/insights",
        data: {
          title: "Insights",
        },
      })
      .state("app.setup.translations", {
        url: "/translations",
        data: {
          title: "Translations",
        },
      })
      .state("app.setup.translations.languages", {
        url: "/languages/:local",
        data: {
          title: "Translations",
        },
      })
      .state("app.setup.forms_settings", {
        url: "/forms-settings",
        data: { title: "Forms" },
      })
      .state("app.patients", {
        url: "/patients",
        data: {
          title: "Patients",
        },
      })
      .state("app.patients.patients", {
        url: "/patients",
        data: {
          title: "Patients",
        },
      })
      .state("app.patients.archived", {
        url: "/archived",
        data: {
          title: "Archived patients",
        },
      })
      .state("app.patient", {
        url: "/patients/:id?tab",
        data: {
          title: "Patients",
        },
      })
      .state("app.insurance-verification", {
        url: "/insurance-verification",
      })
      .state("app.insurance-verification.category", {
        url: "/:category",
      })
      .state("app.treatment-plans", {
        url: "/treatment-plans",
      })
      .state("app.treatment-plans.category", {
        url: "/:category",
      })
      .state("app.payments", {
        url: "/payments",
        data: {
          title: "Payments",
        },
      })
      // This is intentionally not nested under app.payments
      // to hide the tab bar and display a blank page. See the
      // `frontend` repo for page contents.
      .state("app.payments-onboarding", {
        url: "/payments/onboarding",
        data: {
          title: "Payments",
        },
      })
      .state("app.payments-batch-request", {
        url: "/payments/batch-request",
        data: {
          title: "Create batch payment request",
        },
      })
      .state("app.payments.request-payment", {
        url: "/request-payment",
        data: {
          title: "Request Payment",
        },
      })
      .state('app.payments.awaiting-payment', {
        url: '/awaiting-payment',
        data: {
          title: 'Awaiting Payment',
        },
      })
      .state('app.payments.payment-plans', {
        url: '/payment-plans?status',
        data: {
          title: 'Payment Plans',
        },
      })
      .state('app.payments.needs-syncing', {
        url: '/needs-syncing',
        data: {
          title: 'Needs Syncing',
        },
      })
      .state("app.create-bulk-payment-request", {
        url: "/create-bulk-payment-request",
        data: {
          title: "Create bulk payment request",
        },
      })
      .state("app.payments.transaction-history", {
        url: "/transaction-history?payment",
        data: {
          title: "Transaction History",
        },
        params: {
          payment: null,
        }
      })
      .state("app.payments.patients", {
        url: "/patients",
        data: {
          title: "Patients",
        },
      })
      .state("app.calendar", {
        url: "/calendar",
        data: {
          title: "Calendar",
        },
      })
      .state("app.appointment-slots-waitlist-request", {
        url: "/waitlist/request?pid&tab&time&operatory_uuid",
        params: {
          pid: null,
          tab: null,
          time: null,
          operatory_uuid: null,
        },
      })
      .state("app.appointment-slots-waitlist-completed", {
        url: "/waitlist/completed",
      })
      .state("app.appointment-slots-waitlist-your-waitlist", {
        url: "/waitlist/your-waitlist",
      })
      .state("app.appointment-slots-waitlist-waitlist-request-details", {
        url: "/waitlist/:id",
      })
      .state("app.appointment-slots-waitlist", {
        url: "/waitlist",
      })
      .state("app.appointment-slots-waitlist-on-waitlist", {
        url: "/waitlist/on-waitlist",
      })
      .state("app.guides", {
        url: "/guides/:guide",
        data: {
          title: "Guide",
        },
      })
      .state("app.messages", {
        url: "/messages",
        data: {
          title: "Messages",
        },
      })
      .state('app.messages.new', {
        url: '/new?phone',
      })
      .state('app.messages.unread', {
        url: '/unread',
      })
      .state('app.messages.unread.message', {
        url: '/:id?location_id',
      })
      .state('app.messages.archive', {
        url: '/archive',
      })
      .state('app.messages.archive.message', {
        url: '/:id?location_id',
      })
      .state('app.messages.attention', {
        url: '/attention',
      })
      .state('app.messages.attention.message', {
        url: '/:id?location_id',
      })
      .state('app.messages.assistant', {
        url: '/assistant',
      })
      .state('app.messages.assistant.message', {
        url: '/:id?location_id',
      })
      .state('app.messages.front-desk', {
        url: '/front-desk',
      })
      .state('app.messages.front-desk.message', {
        url: '/:id?location_id',
      })
      .state('app.messages.me', {
        url: '/me',
      })
      .state('app.messages.me.message', {
        url: '/:id?location_id',
      })
      .state('app.messages.me.archived', {
        url: '/archived',
      })
      .state('app.messages.me.archived.message', {
        url: '/:id?location_id',
      })
      .state('app.messages.me.unread', {
        url: '/unread',
      })
      .state('app.messages.me.unread.message', {
        url: '/:id?location_id',
      })
      .state('app.messages.message', {
        url: '/:id?location_id',
        params: {
          show_conversations_list: true,
          clear_unread_messages_count: false,
        },
      })
      // Landing Pages
      .state("confirm-appt", {
        url: "/confirm_appt/:code",
        resolve: helper.resolveFor("legacy"),
        controller: "patientApptConfirmCtrl",
        templateUrl: helper.basepath("landing-pages/appointment/confirm.html"),
        data: {
          title: "Confirm Appointment",
        },
      })
      .state("confirm-appointment-slots-waitlist", {
        url: "/confirm_waitlist/:code",
        resolve: helper.resolveFor("legacy"),
        controller: "patientAppointmentSlotsWaitlistConfirmCtrl",
        templateUrl: helper.basepath(
          "landing-pages/appointment_slots_waitlist_confirm.html"
        ),
        data: {
          title: "Confirm Waitlist",
        },
      })
      .state("treatment-plan", {
        url: "/tp/:code",
        template: "<nh-treatment-plan></nh-treatment-plan>",
        data: {
          title: "Treatment Plan",
        },
      })
      // Temp, remove after use
      .state("spine-clinical-upcoming-appointment", {
        url: "/spine-clinical-upcoming-appointment",
        templateUrl: helper.basepath(
          "temp/spine-clinical/email/upcoming-appointment.html"
        ),
        data: {
          title: "Email",
        },
      })
      .state("spine-clinical-intake-form-patient", {
        url: "/spine-clinical-intake-form-patient",
        templateUrl: helper.basepath(
          "temp/spine-clinical/intake-form-patient-view.html"
        ),
        data: {
          title: "Email Reminder",
        },
      })
      .state("spine-clinical-activities", {
        url: "/spine-clinical-activities",
        templateUrl: helper.basepath("temp/spine-clinical/activities.html"),
        data: {
          title: "Email Reminder",
        },
      })
      .state("spine-clinical-intake-form-provider", {
        url: "/spine-clinical-intake-form-provider",
        resolve: helper.resolveFor("legacy"),
        controller: "spineClinicalForm",
        templateUrl: helper.basepath(
          "temp/spine-clinical/intake-form-provider-view.html"
        ),
        data: {
          title: "Email Reminder",
        },
      })
      .state("spring-street-derm-upcoming-appointment", {
        url: "/spring-street-derm-upcoming-appointment",
        templateUrl: helper.basepath(
          "temp/spring-street-derm/email/upcoming-appointment.html"
        ),
        data: {
          title: "Email",
        },
      })
      .state("app.form-responses", {
        url: "/form-responses",
        templateUrl: helper.basepath("form-responses/layout.html"),
        controller: "FormResponsesCtrl",
        resolve: helper.resolveFor("legacy", "ngTable"),
        data: {
          title: "Forms",
        },
      })
      .state("app.enlive", {
        url: "/enlive",
        resolve: helper.resolveFor("legacy"),
        templateUrl: helper.basepath("enlive/layout.html"),
        controller: "EnliveCtrl",
        data: {
          title: "Forms",
        },
      })
      .state("app.enlive.requests", {
        url: "/requests",
        templateUrl: helper.basepath("enlive/requests/layout.html"),
        controller: "EnliveRequestsCtrl",
        resolve: helper.resolveFor("ngTable"),
        data: {
          title: "Form Requests",
        },
      })
      .state("app.enlive.forms", {
        url: "/forms",
        templateUrl: helper.basepath("enlive/forms/layout.html"),
        controller: "EnliveFormsCtrl",
        resolve: helper.resolveFor("ngTable"),
        data: {
          title: "Forms & Packets",
        },
      })
      .state("app.enlive.settings", {
        url: "/settings",
        templateUrl: helper.basepath("enlive/settings/layout.html"),
        controller: "EnliveSettingsCtrl",
        data: {
          title: "Settings",
        },
      })
      .state("app.applications", { url: "/applications" });
  },
])
  .config([
    "$ocLazyLoadProvider",
    "APP_REQUIRES",
    function ($ocLazyLoadProvider, APP_REQUIRES) {
      "use strict";

      // Lazy Load modules configuration
      $ocLazyLoadProvider.config({
        debug: false,
        events: true,
        modules: APP_REQUIRES.modules,
      });
    },
  ])
  .config([
    "$controllerProvider",
    "$compileProvider",
    "$filterProvider",
    "$provide",
    function (
      $controllerProvider,
      $compileProvider,
      $filterProvider,
      $provide
    ) {
      "use strict";
      // registering components after bootstrap
      App.controller = $controllerProvider.register;
      App.directive = $compileProvider.directive;
      App.filter = $filterProvider.register;
      App.factory = $provide.factory;
      App.service = $provide.service;
      App.constant = $provide.constant;
      App.value = $provide.value;
    },
  ])
  .config([
    "cfpLoadingBarProvider",
    function (cfpLoadingBarProvider) {
      cfpLoadingBarProvider.includeBar = true;
      cfpLoadingBarProvider.includeSpinner = false;
      cfpLoadingBarProvider.latencyThreshold = 500;
      cfpLoadingBarProvider.parentSelector = "#main";
    },
  ])
  .filter("capitalize", function () {
    return function (input, scope) {
      if (input != null) {
        input = input.toLowerCase();
        return input.substring(0, 1).toUpperCase() + input.substring(1);
      }
    };
  })
  .filter("tel", function () {
    return function (tel) {
      if (!tel) {
        return "";
      }

      var value = tel.toString().trim().replace(/^\+/, "");

      if (value.match(/[^0-9]/)) {
        return tel;
      }

      var country, city, number;

      switch (value.length) {
        case 10: // +1PPP####### -> C (PPP) ###-####
          country = 1;
          city = value.slice(0, 3);
          number = value.slice(3);
          break;

        case 11: // +CPPP####### -> CCC (PP) ###-####
          country = value[0];
          city = value.slice(1, 4);
          number = value.slice(4);
          break;

        case 12: // +CCCPP####### -> CCC (PP) ###-####
          country = value.slice(0, 3);
          city = value.slice(3, 5);
          number = value.slice(5);
          break;

        default:
          return tel;
      }

      if (country == 1) {
        country = "";
      }

      number = number.slice(0, 3) + "-" + number.slice(3);

      return (country + " (" + city + ") " + number).trim();
    };
  });
